import { useCallback, useState } from 'react';

/**
 * Свёрнуто или развёрнуто — помнится на этом устройстве.
 *
 * Свернул таблицу работ или подсказку по нормам — на следующей карточке
 * сворачивать их заново незачем: человек уже сказал, что ему это не
 * нужно перед глазами. Это удобство одного устройства, а не данные:
 * лежит в памяти браузера, и если она недоступна (приватное окно,
 * запрет), экран просто живёт с умолчанием.
 */
export function useRememberedFlag(key: string, initial: boolean): [boolean, (next: boolean) => void] {
  const [value, setValue] = useState<boolean>(() => {
    try {
      const saved = window.localStorage.getItem(key);
      return saved === null ? initial : saved === '1';
    } catch {
      return initial;
    }
  });
  const set = useCallback(
    (next: boolean) => {
      setValue(next);
      try {
        window.localStorage.setItem(key, next ? '1' : '0');
      } catch {
        // Не запомнилось — в следующий раз будет как по умолчанию
      }
    },
    [key],
  );
  return [value, set];
}
